import {charcoal} from '../../sass/v2/_exports.sass';

export const TrashIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2.66667H12C10.5293 2.66667 9.33333 3.86267 9.33333 5.33334V8.00001H4V10.6667H6.66667V26.6667C6.66667 28.1373 7.86267 29.3333 9.33333 29.3333H22.6667C24.1373 29.3333 25.3333 28.1373 25.3333 26.6667V10.6667H28V8.00001H22.6667V5.33334C22.6667 3.86267 21.4707 2.66667 20 2.66667ZM12 5.33334H20V8.00001H12V5.33334ZM22.6667 26.6667H9.33333V10.6667H22.6667V26.6667Z"
        fill={color}
      />
    </svg>
  );
};
